import { CommonModule } from "@angular/common";
import { Component, DestroyRef, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslatePipe } from "../i18n/translate.pipe";
import { ToastService, ToastType } from "../services/toast.service";

@Component({
  selector: "app-toast",
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: "./toast.component.html",
  styleUrl: "./toast.component.scss",
})
export class ToastComponent implements OnInit {
  message: string = "";
  type: ToastType = "success";
  showToast: boolean = false;

  constructor(
    private toastService: ToastService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.toastService.toast$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((toast) => {
        this.message = toast.message;
        this.type = toast.type;
        this.showToast = toast.showToast;
      });
  }

  get titleKey(): string {
    return `toast.${this.type}`;
  }

  closeToast(): void {
    this.toastService.hideToast();
  }
}
